import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import { useLazyGetNewOrders2QuantityQuery, useLazyGetNewOrdersQuantityQuery } from "store/api/ordersApi"

interface UseNewOrdersQuantityOptions {
  enabled?: boolean
}

export const useNewOrdersQuantity = (options?: UseNewOrdersQuantityOptions) => {
  const { enabled = true } = options || {}
  const location = useLocation()
  const pathname = location.pathname

  const useNewQuery = !pathname.includes("order-legacy")

  const [triggerGetNewOrdersQuantity, { data: dataOld }] = useLazyGetNewOrdersQuantityQuery()
  const [triggerGetNewOrders2Quantity, { data: dataNew }] = useLazyGetNewOrders2QuantityQuery()

  const triggerGetNewOrdersQuantityFinal = useNewQuery ? triggerGetNewOrders2Quantity : triggerGetNewOrdersQuantity
  const data = useNewQuery ? dataNew : dataOld

  useEffect(() => {
    if (!enabled) return

    const fetchData = async () => {
      try {
        await triggerGetNewOrdersQuantityFinal()
      } catch (error) {
        console.error(error)
      }
    }

    const intervalId = setInterval(fetchData, 60000)
    fetchData()
    return () => clearInterval(intervalId)
  }, [triggerGetNewOrdersQuantityFinal, enabled])

  return {
    data,
    triggerGetNewOrdersQuantity: triggerGetNewOrdersQuantityFinal,
  }
}
